import { Inject, Injectable } from '@angular/core';
import { DomService } from './dom.service';
import * as removeAccents from 'remove-accents';
import { NavbarService } from './navbar.service';

@Injectable({
  providedIn: 'root',
})
export class TrackingService {
  private specialCharsRegexToReplaceWithUnderscore = /[ \'"/,]/g;
  private specialCharsRegexToReplaceWithEmpty = /[^a-zA-Z0-9_|-]/g;
  constructor(
    @Inject('EnvironmentProvider') public environmentProvider,
    private navbarService: NavbarService,
    private domService: DomService
  ) {}

  trackView(): void {
    if (this.environmentProvider.tracking) {
      this.navbarService.trackView();
    }
  }

  trackLink(zone: string, name: string, cible?: string): void {
    if (this.environmentProvider.tracking) {
      if (cible) {
        this.navbarService.trackLink(
          this.convertToTrackingFormat(zone),
          this.convertToTrackingFormat(name),
          this.convertToTrackingFormat(cible)
        );
      } else {
        this.navbarService.trackLink(this.convertToTrackingFormat(zone), this.convertToTrackingFormat(name));
      }
    }
  }

  private convertToTrackingFormat(value: string): string {
    const decodedValue = this.domService.getDocument().createElement('div');
    decodedValue.innerHTML = value;
    if (decodedValue.textContent) {
      const valueWithoutAccents = removeAccents.remove(decodedValue.textContent);
      const valueSpecialCharsReplacedWithUnderscore = valueWithoutAccents.replace(
        this.specialCharsRegexToReplaceWithUnderscore,
        '_'
      );
      return valueSpecialCharsReplacedWithUnderscore
        .replace(this.specialCharsRegexToReplaceWithEmpty, '')
        .toLowerCase();
    } else {
      return '';
    }
  }
}
